var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmSales = function SvgBmSales(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-325 -58)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 18,
    height: 18,
    transform: "translate(325 58)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(267.446 262.078)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.823-188.072a1.3,1.3,0,0,1-.956.394,1.3,1.3,0,0,1-.956-.394l-5.963-5.963a1.3,1.3,0,0,1-.394-.956v-5.738a1.3,1.3,0,0,1,.394-.956,1.3,1.3,0,0,1,.956-.394h5.738a1.3,1.3,0,0,1,.956.394l5.963,5.963a1.3,1.3,0,0,1,.394.956,1.3,1.3,0,0,1-.394.956Zm3.6,0a1.3,1.3,0,0,1-.956.394,1.3,1.3,0,0,1-.956-.394l6.694-6.694-7.34-7.313h1.378a1.3,1.3,0,0,1,.956.394l5.963,5.963a1.3,1.3,0,0,1,.394.956,1.3,1.3,0,0,1-.394.956Zm-8.775-10.913a1.3,1.3,0,0,0-.394.956,1.3,1.3,0,0,0,.394.956,1.3,1.3,0,0,0,.956.394,1.3,1.3,0,0,0,.956-.394,1.3,1.3,0,0,0,.394-.956,1.3,1.3,0,0,0-.394-.956,1.3,1.3,0,0,0-.956-.394A1.3,1.3,0,0,0,60.648-198.984Z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmSales, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_Sales.8c36c4a9.svg";
export { ForwardRef as ReactComponent };